import { widgetOptions } from 'src/constants/widgetOptions';
interface WidgetIconProps {
  id: string;
  title: string;
}

export const getWidgetOptionItems = (): WidgetIconProps[] => {
  return widgetOptions.reduce((acc: WidgetIconProps[], widget) => {
    const optionsIcons = widget.options.map((option) => ({
      id: option.id,
      title: option.title,
    }));
    return [...acc, ...optionsIcons];
  }, []);
};
